module.exports = __webpack_public_path__ + "img/edit.4e7a0b75.svg";